import { BaseModel } from "models/BaseModel";

export interface Inventory extends BaseModel {
  inventory_id?: number;
  inventory_key?: string;
  inventory_active?: number;
  inventory_date?: Date;
  product_id?: number;
  product_name?: string;
  stock_id?: number;
  stock_name?: string;
  specification_id?: number;
  specification_name?: string;
  inventory_sale_price?: number;
  inventory_purchase_price?: number;
  inventory_deposit_price?: number;
  inventory_cost_price?: number;
  inventory_paid_price?: number;
  inventory_stock?: number;
  inventory_utncode?: string;
  inventory_skucode?: string;
  inventory_serialno?: string;
  inventory_data?: string;
  inventory_comment?: string;
  inventory_ref_number?: string;
}


export const inventoryKeys: (keyof Inventory)[] = [
  "inventory_id",
  "inventory_key",
  "company_id",
  "location_id",
  "user_id",
  "inventory_active",
  "inventory_date",
  "product_id",
  "type_id",
  "status_id",
  "client_id",
  "inventory_sale_price",
  "inventory_purchase_price",
  "inventory_deposit_price",
  "inventory_cost_price",
  "inventory_paid_price",
  "inventory_stock",
  "inventory_utncode",
  "inventory_skucode",
  "inventory_serialno",
  "inventory_data",
  "inventory_comment",
  "inventory_ref_number"
];
